import React, { Component } from "react";
import "component/common/ModalHeader/styles.scss";

import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";

class ModalHeader extends Component {
  render() {
    return (
      <div className="common-modal-header row">
        <div className="col-auto">
          {this.props.onClickPrevious && (
            <span
              className="float-left prev-btn"
              onClick={this.props.onClickPrevious}
            >
              <PreviousIcon width="34" />
            </span>
          )}
        </div>
        {this.props.title && (
          <div
            className={`col title d-flex align-items-center ${
              this.props.showTitle ? "fade-in" : ""
            }`}
          >
            <div className="action-name w-100 text-center">
              <span>{this.props.title}</span>
            </div>
          </div>
        )}
        {!this.props.title && <div className="col title" />}
        <div className="col-auto">
          {this.props.onCloseClickHandler && (
            <CloseIcon width="34" onClick={this.props.onCloseClickHandler} />
          )}
        </div>
      </div>
    );
  }
}

export default ModalHeader;
